import {useQuery} from "@apollo/client";
import {useState, useEffect} from "react";
import {
    ZipcodeType,
    ZipcodeListResponse,
    GET_ZIPCODE_LISTING,
    ZipcodeFiltersType
} from "../graphql/queries/getZipcodeListing";

interface ZipcodeQueryResult {
    zipcodeData: ZipcodeType[];
    loading: boolean;
    refetch: (variables?: any) => void;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useZipcodeQuery = (
    filters: ZipcodeFiltersType,
    currentPage: number,
    pageSize: number
): ZipcodeQueryResult => {
    const [zipcodeData, setZipcodeData] = useState<ZipcodeType[]>([]);
    const [loading, setLoading] = useState(true);
    
    // 构建GraphQL查询参数
    const buildQueryVariables = () => {
        return {
            filters: filters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "zipcode",
                sortDirection: "ASC"
            }
        };
    };

    const { data, loading: queryLoading, refetch } = useQuery<ZipcodeListResponse>(
        GET_ZIPCODE_LISTING,
        {
            variables: buildQueryVariables(),
            fetchPolicy: 'cache-and-network'
        }
    );

    useEffect(() => {
        setLoading(queryLoading);
        if (data?.getBlacklitZipcodeListing) {
            setZipcodeData(data.getBlacklitZipcodeListing.content || []);
        }
    }, [data, queryLoading]);

    const totalElements = data?.getBlacklitZipcodeListing?.totalElements || 0;

    return {
        zipcodeData,
        loading,
        refetch,
        totalElements,
        buildQueryVariables
    };
}; 